import { Link } from 'react-router-dom';
import { brand } from '@/config/brand';

export function AboutPage() {
  return (
    <article className="panel prose-page">
      <h1>About {brand.name}</h1>
      <p>
        {brand.name} is a free comparison tool for adults who want clear numbers
        on how drinks stack up by alcohol content, calories, and package cost.
        The public site is {brand.domain}. Comparisons stay usable without an
        account, without downloads, and without a runtime application backend.
      </p>

      <h2>What problem we solve</h2>
      <p>
        Labels and store shelves make it hard to answer simple questions: which
        light beer delivers more alcohol for the calories? Does a stronger IPA
        still look “efficient” once you normalize servings? Is a cheaper case
        actually better value once you account for volume and ABV? {brand.name}{' '}
        puts those comparisons in one place using consistent units and two
        primary ratios — alcohol per 100 calories and alcohol per dollar —
        instead of marketing claims or vague “light” language.
      </p>

      <h2>What this site is not</h2>
      <p>
        {brand.positioning} There is no blood-alcohol estimator, no “how to get
        drunk for less” framing, and no target-intoxication features. We do not
        sell alcohol, take orders, or send you to checkout flows. Standard-drink
        math is for composition and labeling literacy — not a promise that two
        drinks will feel the same.
      </p>

      <h2>How the catalog is curated</h2>
      <p>
        The catalog mixes producer-verified nutrition where we have it, regional
        reference prices (for example Virginia ABC for liquor and wine, and
        retail snapshots for beer), recipe estimates for mixed drinks, and
        explicit “unknown” fields when data is missing. Unknown is never
        silently turned into zero. You can override package prices in your
        browser for local shopping trips; those overrides stay on your device
        unless you choose to include them in a share link.
      </p>
      <p>
        For the math behind the rankings, read the{' '}
        <Link to="/methodology/">Methodology</Link> page. For worked examples and
        category explainers, browse the <Link to="/guides/">Guides</Link>.
      </p>

      <h2>Ads and access</h2>
      <p>
        Access to comparisons is free. Display advertising may appear later on
        substantial pages (guides and explainers) to help host the site.
        Interactive tools remain usable if ads are absent, blocked, or not yet
        approved. See <Link to="/privacy/">Privacy</Link> for how preferences and
        any future ad consent are handled.
      </p>

      <h2>Contact</h2>
      <p>
        Request a missing drink, flag bad data, or suggest an improvement via the{' '}
        <Link to="/feedback/">feedback form</Link>
        {brand.contactEmail ? (
          <>
            {' '}
            or <a href={`mailto:${brand.contactEmail}`}>{brand.contactEmail}</a>
          </>
        ) : null}
        . Recent product and content updates are listed on{' '}
        <Link to="/changelog/">What’s new</Link>.
      </p>

      <p>{brand.adultNotice}</p>
    </article>
  );
}
